import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConteoDocumentos {
  pasaportes: number;
  informesMedicos: number;
  recetasMedicas: number;
  facturas: number;
  soportes: number;
  otros: number;
}

@Component({
  selector: 'app-review-dialog',
  templateUrl: './review-dialog.component.html',
  styleUrls: ['./review-dialog.component.scss'],
})
export class ReviewDialogComponent {
  constructor(
    private referenciaModal: MatDialogRef<ReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public datosDocumentos: ConteoDocumentos,
  ) {}

  closeDialog(accion: string): void {
    this.referenciaModal.close(accion);
  }
}
